import { createSelector } from 'reselect';
import {
  dictionariesStateSelector,
  textTemplatesSelector,
  themesSelector
} from "../dictionaries/selectors";

export const createLlamaStateSelector = state => state.stickers.createLlama;

export const createLlamaFormSelector = createSelector(
  createLlamaStateSelector,
  state => state.form
);

export const createLlamaIdSelector = createSelector(
  createLlamaStateSelector,
  state => state.scannedSticker && state.scannedSticker.id
);


export const createStickerItemIdSelector = createSelector(
    createLlamaStateSelector,
    state => state.scannedSticker && state.scannedSticker.id
);

export const createStickerIdSelector = createSelector(
    createLlamaStateSelector,
    state => state.scannedSticker && state.scannedSticker.sticker_id
);


export const createLlamaFormatSelector = createSelector(
  createLlamaStateSelector,
  state => state.form.format
);

export const createLlamaUploadedMediaSelector = createSelector(
  createLlamaStateSelector,
  state => state.uploadedMedia
);

export const createLlamaActiveGroupThemesSelector = createSelector(
  createLlamaStateSelector,
  themesSelector,
  (state, themesList) => {
    const groupId = state.formTemp.template_group;
    if (groupId != null && themesList && themesList.length) {
      return themesList.filter((theme) =>
        Object.keys(theme.group_ids).some((id) => id == groupId)
      ).sort((a, b) => a.group_ids[groupId] - b.group_ids[groupId]);
    }
    return null;
  }
);

export const createLlamaActiveThemesGroupSelector = createSelector(
  dictionariesStateSelector,
  createLlamaStateSelector,
  (dictionaries, state) => {
    const groupThemeId = state.formTemp.template_group;
    if (dictionaries && groupThemeId != null) {
      return dictionaries.themesGroupsByIds[groupThemeId];
    }
    return null
  }
);

export const createLlamaActiveThemeSelector = createSelector(
  dictionariesStateSelector,
  createLlamaStateSelector,
  (dictionaries, state) => {
    const themeId = state.form.template;
    if (dictionaries && themeId != null) {
      return dictionaries.themesTemplatesByIds[themeId];
    }
    return null
  }
);

export const greetingTextSelector = createSelector(
  createLlamaStateSelector,
  state => state.form.greeting_text
);


// Text templates group
export const createLlamaActiveGroupTextTemplatesSelector = createSelector(
  dictionariesStateSelector,
  createLlamaStateSelector,
  (dictionaries, state) => {
    const groupId = state.formTemp.text_template_group.toString();
    if (dictionaries && groupId != null) {
      return dictionaries.textsGroupsByIds[groupId];
    }
    return null
  }
);

export const createLlamaActiveGroupTemplatesSelector = createSelector(
  createLlamaStateSelector,
  textTemplatesSelector,
  (state, templatesList) => {
    const groupId = state.formTemp.text_template_group.toString();
    if (groupId != null && templatesList && templatesList.length) {
      return templatesList
          .filter((template) => Object.keys(template.group_ids).some((id) => id == groupId))
          .sort((a, b) => a.group_ids[groupId] - b.group_ids[groupId]);
    }
    return null;
  }
);

export const createLlamaActiveTemplateSelector = createSelector(
  dictionariesStateSelector,
  createLlamaStateSelector,
  (dictionaries, state) => {
    const templateId = state.formTemp.text_template;
    if (dictionaries && templateId != null) {
      return dictionaries.textsTemplatesByIds[templateId];
    }
    return null
  }
);

export const createLlamaTypeSelector = createSelector(
    createLlamaStateSelector,
    state => state.scannedSticker && state.scannedSticker.type
);

export const createLlamaShowAnimationSelector = createSelector(
    createLlamaTypeSelector,
    type => type == "GREETING"
);

export const createLlamaShowThemeSelector = createSelector(
    createLlamaTypeSelector,
    type => type == "GREETING"
);

export const createLlamaShowTemplatesSelector = createSelector(
    createLlamaTypeSelector,
    type => type == "GREETING"
);
